// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__O7qU-","wrapper":"style_wrapper__3RBY-"};